// src/features/master-data/services/masterDataApi.js
import httpClient from '../../../shared/services/httpClient';
import { apiEndpoints } from '../config/masterDataConfig';

export const masterDataApi = {
  // Generic CRUD operations
  getAll: (type, params = {}) => {
    return httpClient.get(apiEndpoints[type], { params });
  },

  getById: (type, id) => {
    return httpClient.get(`${apiEndpoints[type]}/${id}`);
  },

  create: (type, data) => {
    return httpClient.post(apiEndpoints[type], data);
  },

  update: (type, id, data) => {
    return httpClient.patch(`${apiEndpoints[type]}/${id}`, data);
  },
    
  toggle_status: (type, id) => {
    return httpClient.patch(`${apiEndpoints[type]}/${id}/toggle-status`);
  },

  delete: (type, id) => {
    return httpClient.delete(`${apiEndpoints[type]}/${id}`);
  },

  bulkDelete: (type, ids) => {
    return httpClient.post(`${apiEndpoints[type]}/bulk-delete`, { ids });
  },

  // Additional operations
  getOptions: (type, field) => {
    return httpClient.get(`${apiEndpoints[type]}/options/${field}`);
  },

  import: (type, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.post(`${apiEndpoints[type]}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  export: (type, params = {}) => {
    return httpClient.get(`${apiEndpoints[type]}/export`, {
      params,
      responseType: 'blob',
    });
  },

  // Specific endpoints for related data
  getCategories: (params = {}) => {
    return httpClient.get('/master/categories', { params });
  },

    getMedicines: (params = {}) => {
    return httpClient.get('/master/medicines', { params });
  },

  getUnits: (params = {}) => {
    return httpClient.get('/master/units', { params });
  },

  getSuppliers: (params = {}) => {
    return httpClient.get('/master/suppliers', { params });
  },

  getLocations: (params = {}) => {
    return httpClient.get('/master/locations', { params });
  },

  getDepartments: (params = {}) => {
    return httpClient.get('/master/departments', { params });
  },
};